import { IPromotionsCategories } from '@llws/lift-entity-interfaces';
import { snakeToCamel } from './snake-to-camel';
import { TPromotionFieldKeyCamel, TPromotionsCategoryRulesCamel } from '../types/promotions-categories';
import { IPromotionsCategoriesCamel } from '../interfaces/promotions-categories';

/**
 * Converts promotion category data values from the backend to camelCase key references.
 * Specifically converts:
 * - promotionsFields[].key
 * - rules[].field
 * - rules[].fields[]
 * @param categories - Categories options sent by the BE
 * @returns A new array of promotion category objects with the keys' values mentioned above converted to camelCase.
 */
export const camelizePromotionsCategories = (categories: IPromotionsCategories[]): IPromotionsCategoriesCamel[] => categories.map((category) => {
  const updatedFields = category.promotionsFields?.map((field) => ({
    ...field,
    key: snakeToCamel(field.key) as TPromotionFieldKeyCamel,
  })) ?? [];

  const updatedRules: TPromotionsCategoryRulesCamel[] = category.rules?.map((rule) => {
    if ('field' in rule) {
      return {
        ...rule,
        field: snakeToCamel(rule.field) as TPromotionFieldKeyCamel,
      };
    }

    if ('fields' in rule) {
      return {
        ...rule,
        fields: rule.fields.map(
          (f) => snakeToCamel(f) as TPromotionFieldKeyCamel,
        ),
      };
    }

    return rule as TPromotionsCategoryRulesCamel;
  }) ?? [];

  return {
    ...category,
    promotionsFields: updatedFields,
    rules: updatedRules,
  };
});
